module.exports = __webpack_public_path__ + "static/img/customer-supplied-product.7d4e68c.png";